import { useEffect, useState } from "react";
import api from "../api/api";

function VendorAreaList() {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/vendor-areas")
      .then(res => setData(Array.isArray(res.data) ? res.data : []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted fs-13">Loading assignments…</p>;

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">📋 Vendor Area Assignments</div>
        <span className="badge badge-muted">{data.length} vendors</span>
      </div>

      {data.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🔗</div>
          <div className="empty-title">No assignments yet</div>
          <div className="empty-sub">Use the form above to assign vendors to areas</div>
        </div>
      ) : (
        <div className="card-body no-pad">
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Vendor</th><th>Assigned Areas</th></tr>
              </thead>
              <tbody>
                {data.map(v => (
                  <tr key={v.vendorName}>
                    <td><strong>{v.vendorName}</strong></td>
                    <td>
                      {v.areas?.length > 0
                        ? v.areas.map((a, i) => (
                            <span key={i} className="badge badge-muted" style={{ marginRight: 4 }}>{a}</span>
                          ))
                        : <span className="text-muted fs-12">No areas assigned</span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default VendorAreaList;
